import type { Group, GroupDateAnnotation } from "@shared/models/group"
import type { PatchModel } from "@shared/models/patch"
import Patch from "@shared/models/patch-updater"
import type { PreparedAction } from "@shared/actions/action-doc-builder"
import { partial } from "lodash"
import moment from "moment"
import type { Narrative } from "@shared/actions/create-narrative"

interface Payload {
  annotation: GroupDateAnnotation
  group: Group
}

export function prepareGroupDateAnnotationCreate(payload: Payload): PreparedAction {
  return {
    name: "GROUP_DATE_ANNOTATION_CREATE",
    payload: payload,
    patches: patches(payload),
    undoPatches: undoPatches,
    narrative: partial(narrative, payload),
  }
}

export function patches(payload: Payload): Array<PatchModel> {
  const patch = Patch.create("group", payload.group.id).push(
    "attributes.calendar.dateAnnotations",
    payload.annotation
  )

  return [patch.patch]
}

export const undoPatches = null

export function narrative(payload: Payload, findFn: Function, userId: string): Narrative {
  let formattedStartDate = moment(payload.annotation.attributes.startDate).format(
    "ddd, MMM. D, YYYY"
  )
  let formattedEndDate = moment(payload.annotation.attributes.endDate).format("ddd, MMM. D, YYYY")

  return {
    title: "Created Group Calendar Event",
    titleForAnalytics: "Group - Calendar - Create Annotation",
    description: `Added Group Calendar Event from ${formattedStartDate} to ${formattedEndDate}`,
    context: {
      // Note: groupId gets clobbered by Store's generateActionDoc, so we use a different name.
      calendarGroupId: payload.group.id,
      dateAnnotationId: payload.annotation.id,
      isOff: payload.annotation.attributes.isOff,
    },
    activity: null,
  }
}
